import { useAuth } from "oidc-react";

const Login = () => {
  const auth = useAuth();

  return (
    <div>
      <h1>Login</h1>
      <button onClick={() => auth.signIn()}>Sign In</button>
    </div>
  );
};

export default Login;
